import { render, staticRenderFns } from "./DIS_Benefit.vue?vue&type=template&id=d6a883c2&"
import script from "./DIS_Benefit.vue?vue&type=script&lang=js&"
export * from "./DIS_Benefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports